import {atom} from "recoil";

const editingOperatorIdState = atom<string | undefined>({
    key: "editing-operator-id",
    default: undefined
});

export default editingOperatorIdState;
